export default {
  app: {
    tradeOffers: {
      country: 'Valsts',
      loginPrompt: 'Lai piekļūtu piedāvājumam, Jums vajag {0}.',
      logIn: 'pierakstīties',
    },
  },
};
